import React, { useContext } from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import Typed from 'react-typed';
import { 
    FaFacebook, FaGithub, FaInstagram, FaLinkedin, FaTwitter 
} from 'react-icons/fa';

import { ThemeContext } from '../../contexts/ThemeContext';
import { headerData } from '../../data/headerData';
import { socialsData } from '../../data/socialsData';
import './Landing.css';

const useStyles = makeStyles((t) => ({
    resumeBtn: {
        color: ({ theme }) => theme.primary,
        borderRadius: '30px',
        textTransform: 'inherit',
        textDecoration: 'none',
        width: '150px',
        fontSize: '1rem',
        fontWeight: '500',
        height: '50px',
        fontFamily: 'var(--primaryFont)',
        border: ({ theme }) => `3px solid ${theme.primary}`,
        transition: '100ms ease-out',
        '&:hover': {
            backgroundColor: ({ theme }) => theme.buttonColor,
            color: ({ theme }) => theme.secondary,
            border: ({ theme }) => `3px solid ${theme.buttonColor}`,
        },
        [t.breakpoints.down('sm')]: {
            width: '180px',
        },
    },
    contactBtn: {
        backgroundColor: ({ theme }) => theme.primary,
        color: ({ theme }) => theme.secondary,
        borderRadius: '30px',
        textTransform: 'inherit',
        textDecoration: 'none',
        width: '150px',
        height: '50px',
        fontSize: '1rem',
        fontWeight: '500',
        fontFamily: 'var(--primaryFont)',
        border: ({ theme }) => `3px solid ${theme.primary}`,
        transition: '100ms ease-out',
        '&:hover': {
            backgroundColor: ({ theme }) => theme.buttonColor,
            color: ({ theme }) => theme.secondary,
            border: ({ theme }) => `3px solid ${theme.buttonColor}`,
        },
        [t.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
}));

function Landing() {
    const { theme, drawerOpen } = useContext(ThemeContext);
    const classes = useStyles({ theme }); 

    return (
        <div className='landing' style={{ backgroundColor: theme.quaternary }}>
            <div className='landing--container'>
                <div className='landing--container-left' style={{ backgroundColor: theme.quaternary }}>
                    <div className='lcl--content'>
                        {socialsData.linkedIn && (
                            <a href={socialsData.linkedIn} target='_blank' rel='noreferrer' aria-label='LinkedIn'>
                                <FaLinkedin className='landing--social linkedin-icon' style={{ color: theme.primary }} />
                            </a>
                        )}
                        {socialsData.github && (
                            <a href={socialsData.github} target='_blank' rel='noreferrer' aria-label='GitHub'>
                                <FaGithub className='landing--social' style={{ color: theme.primary }} />
                            </a>
                        )}
                        {socialsData.twitter && (
                            <a href={socialsData.twitter} target='_blank' rel='noreferrer' aria-label='Twitter'>
                                <FaTwitter className='landing--social twitter-icon' style={{ color: theme.primary }} />
                            </a>
                        )}
                        {socialsData.instagram && (
                            <a href={socialsData.instagram} target='_blank' rel='noreferrer' aria-label='Instagram'>
                                <FaInstagram className='landing--social instagram-icon' style={{ color: theme.primary }} />
                            </a>
                        )}
                        {socialsData.facebook && (
                            <a href={socialsData.facebook} target='_blank' rel='noreferrer' aria-label='Facebook'>
                                <FaFacebook className='landing--social facebook-icon' style={{ color: theme.primary }} />
                            </a>
                        )}
                    </div>
                </div>

                <img
                    src={headerData.image}
                    alt={headerData.name || 'Mehedi Hasan'}
                    className='landing--img'
                    style={{
                        opacity: drawerOpen ? '0' : '1',
                        borderColor: theme.primary,
                    }}
                />

                <div className='landing--container-right' style={{ backgroundColor: theme.secondary }}>
                    <div className='lcr--content' style={{ color: theme.tertiary }}>
                        <h3 className='text-center text-2xl md:text-left' style={{ color: theme.primary }}>
                            {headerData.title}
                        </h3>
                        <h1>{headerData.name}</h1>
                        
                        <Typed
                            strings={[
                                'Frontend Developer',
                                'Backend Developer',
                                'MERN stack Developer',
                                'Web Application Developer'
                            ]}
                            typeSpeed={40}
                            backSpeed={50}
                            className="typed-header"
                            style={{ color: theme.primary, fontSize: '20px' }}
                            loop
                        />
                        <p>{headerData.description}</p>

                        <div className='lcr-buttonContainer'>
                            <NavLink to='/#contacts' smooth={true} duration={2000}>
                                <Button className={classes.resumeBtn}>
                                    Contact
                                </Button>
                            </NavLink>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Landing;